import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

const PricingPlans = () => {
  const navigate = useNavigate();

  const handleLiveClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) {
      window.location.href = `https://live.baga-tech.com/auth/supabase?token=${token}`;
    } else {
      navigate('/auth');
    }
  };

  const plans = [
    {
      name: 'Ücretsiz',
      price: '₺0',
      period: 'süresiz',
      description: 'BAGA\'yı keşfetmek için ideal başlangıç planı',
      features: [
        'Canlı karar yayın sayfası erişimi',
        'Gerçek zamanlı karar güncellemeleri',
        'Temel karar bilgileri (ALIM/İZLE)',
        'Tüm hisse senetleri için tarama',
        'Tarayıcı üzerinden erişim',
      ],
      cta: 'Ücretsiz Başla',
      popular: false,
      isLive: true,
      link: '#',
    },
    {
      name: 'Pro',
      price: 'Yakında',
      period: '',
      description: 'Gelişmiş özellikler ve detaylı analizler',
      features: [
        'Tüm Ücretsiz plan özellikleri',
        'Detaylı karar analizi ve açıklamaları',
        'Geçmiş karar performans raporları',
        'Özelleştirilebilir bildirimler',
        'Favori hisse listesi oluşturma',
        'Öncelikli destek',
      ],
      cta: 'Bekleme Listesine Katıl',
      popular: true,
      isLive: false,
      link: '#',
    },
  ];

  return (
    <section className="py-32 bg-dark-lighter relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-dark-card rounded-3xl p-10 ${
                plan.popular
                  ? 'border-2 border-emerald shadow-2xl shadow-emerald/20'
                  : 'border border-dark-border'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <div className="bg-gradient-to-r from-emerald to-emerald-light px-6 py-2 rounded-full">
                    <span className="text-white font-bold text-sm whitespace-nowrap">En Popüler</span>
                  </div>
                </div>
              )}

              <div className="mb-8">
                <h3 className="text-3xl font-bold text-beige-light mb-3">{plan.name}</h3>
                <p className="text-beige/70 text-sm">{plan.description}</p>
              </div>

              <div className="mb-8">
                <div className="flex items-baseline gap-2">
                  <span className="text-5xl font-black text-beige-light">{plan.price}</span>
                  {plan.period && (
                    <span className="text-beige/70 text-lg">/ {plan.period}</span>
                  )}
                </div>
              </div>

              <div className="mb-8">
                <ul className="space-y-4">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="w-5 h-5 bg-emerald/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-emerald text-sm"></i>
                      </div>
                      <span className="text-beige/70 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {plan.isLive ? (
                <button
                  onClick={handleLiveClick}
                  className={`block w-full text-center py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    plan.popular
                      ? 'bg-emerald hover:bg-emerald-light text-beige-light shadow-lg shadow-emerald/30 hover:shadow-emerald/50'
                      : 'bg-dark-lighter border border-emerald/30 text-emerald hover:bg-emerald/10'
                  }`}
                >
                  {plan.cta}
                </button>
              ) : (
                <Link
                  to={plan.link}
                  className={`block w-full text-center py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    plan.popular
                      ? 'bg-emerald hover:bg-emerald-light text-beige-light shadow-lg shadow-emerald/30 hover:shadow-emerald/50'
                      : 'bg-dark-lighter border border-emerald/30 text-emerald hover:bg-emerald/10'
                  }`}
                >
                  {plan.cta}
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <p className="text-beige/70 mb-4">Kurumsal çözümler mi arıyorsunuz?</p>
          <a
            href="mailto:info@baga-tech.com"
            className="inline-flex items-center gap-2 text-emerald hover:text-emerald-light font-semibold transition-colors cursor-pointer"
          >
            Bizimle İletişime Geçin
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;
